import { Vegobjekt, VegobjektEgenskap } from '@/domain/vegobjekter/Vegobjekt';

export class VegobjektResponse {
    constructor(
        readonly objekter: Vegobjekt[],
        readonly metadata: VegobjektResponseMetadata
    ) {}
}

export class VegobjektEgenskaperResponse {
    constructor(
        readonly objekter: { id: number; egenskaper: VegobjektEgenskap[] }[],
        readonly metadata: VegobjektResponseMetadata
    ) {}
}

export class VegobjektResponseMetadata {
    constructor(
        readonly returnert: number,
        readonly neste: { start: string; href: string } | undefined,
        readonly sidestorrelse: number
    ) {}
}
